import './DataGroupOverviewView.module'
import dataGroupOverviewPage from './DataGroupOverviewPage.component'
import StoreService from '../../../common/redux/store.service'

export default angular
  .module('components.dataGroupOverviewPage', ['components.tb.dataGroupOverview'])
  .component('dataGroupOverviewPage', dataGroupOverviewPage)
  .service('StoreService', StoreService)
  .config($stateProvider => {
    $stateProvider.state('dataGroupOverview', {
      parent: 'app',
      url: '^/data-group-overview',
      component: 'dataGroupOverviewPage',
      reloadOnSearch: false
    })
  })
  .name
